import React, { useState } from 'react';
import { Button, Modal, Form, Input } from 'antd';
import {EditOutlined} from '@ant-design/icons';

const MakeUpdateForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();
  let make = record
  const [makeID]=useState(make.MakeID)
  const [makeName]=useState(make.Make)

  return (
    <Modal
      visible={visible}
      title="Update Make"
      okText="Update"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="MakeUpdate"
        initialValues={{
            MakeID:makeID,
            Make:makeName
        }}
      >
        <Form.Item
          name="MakeID"
          label="Make ID"
        >
            <Input disabled/>
        </Form.Item>
        <Form.Item
          name="Make"
          label="Make"
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const MakeUpdate = (props) => {
  const [visible, setVisible] = useState(false);

  const onCreate = (values) => {

    props.updateMake(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
        icon={<EditOutlined />}

      >
      </Button>
      <MakeUpdateForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
        record={props.record}
      />
    </div>
  );
};

export default MakeUpdate